import React from 'react'

const CommissionContent = (props) => {
    const commission = props.commission
    const year = props.year
    const chartAgent = props.chartAgent

    const thousandSeparator = nStr => {
        return nStr.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    };

    const formatDate = (datetime) => {
        const datetimeValue = new Date(datetime);
        return `${datetimeValue.toLocaleDateString()}`;
    };

    return (
        <>
            <div className='flex md:flex-row flex-col items-center md:gap-5 gap-2'>
                <div className='border border-border rounded-[10px] h-full w-full flex-1 px-1.5 py-2'>
                    {commission?.individual && <div className="">
                        <canvas id="commissionIndividualBarChart"></canvas>
                    </div>}
                </div>

                <div className='border border-border rounded-[10px] h-full w-full flex-1 px-1.5 py-2'>
                    {commission?.group && <div className="">
                        <canvas id="commissionGroupBarChart"></canvas>
                    </div>}
                </div>
            </div>

            <div className='flex flex-col w-full'>
                <div className='md:flex hidden gap-5 mb-2'>
                    <div className='w-full flex items-start justify-center text-center'>
                        <p className='text-xs font-semibold text-gray-one'>{ `${ year } Completed Sales Commission Performance -  ${ chartAgent?.UserName }` }</p>
                    </div>

                    <div className='w-full flex items-start justify-center text-center'>
                        <p className='text-xs font-semibold text-gray-one'>{ `${ year } Completed Sales Commission Summary Report` }</p>
                    </div>
                </div>

                <div className='flex md:flex-row flex-col gap-5'>
                    <div className="flex-1 flex flex-col">
                        <div className='w-full md:hidden flex mb-2 items-start justify-center text-center'>
                            <p className='text-xs font-semibold text-gray-one'>{ `${ year } Completed Sales Commission Performance -  ${ chartAgent?.UserName }` }</p>
                        </div>

                        <div className='rounded-[10px] border border-border overflow-hidden bg-white'>
                            <div className='overflow-auto'>
                                <table className="w-full">
                                    <thead className="border-b border-border bg-secondary-light text-gray-one">
                                        <tr>
                                            <th scope="col" className="text-xs font-semibold px-3 py-2 whitespace-nowrap text-center">
                                                #
                                            </th>
                                            <th scope="col" className="text-xs font-semibold px-3 py-2 whitespace-nowrap text-left">
                                                Sales Date / Account
                                            </th>
                                            <th scope="col" className="text-xs font-semibold px-3 py-2 whitespace-nowrap text-right">
                                                Commission(RM)
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            (commission || commission?.individualTransactions.length > 0) ?
                                            commission.individualTransactions?.map((item, idx) => {
                                                return <tr key={ item._id } className={ 'border-border text-gray-two ' + (idx !== 0 ? 'border-t' : '') }>
                                                    <td className="px-3 py-2 whitespace-nowrap text-xs font-medium text-center">{`${idx + 1}`}</td>
                                                    <td className="text-xs font-light px-3 py-2 whitespace-nowrap text-left">
                                                        { formatDate(item.CommissionSalesDate) }<br />{ item.CommissionAccount }
                                                    </td>
                                                    <td className="text-xs font-light px-3 py-2 whitespace-nowrap text-right">
                                                        { thousandSeparator(item.CommissionAmount) }
                                                    </td>
                                                </tr>
                                            }) :
                                            <tr className='text-gray-two'>
                                                <td colSpan='100%' className="text-xs font-light px-3 py-2 whitespace-nowrap text-center">There is no data</td>
                                            </tr>
                                        }
                                
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                
                    <div className="flex-1 flex flex-col">
                        <div className='w-full md:hidden flex mb-2 items-start justify-center text-center'>
                            <p className='text-xs font-semibold text-gray-one'>{ `${ year } Completed Sales Commission Summary Report` }</p>
                        </div>
                        
                        <div className="rounded-[10px] border border-border overflow-hidden bg-white">
                            <div className='overflow-auto'>
                                <table className="w-full">
                                    <thead className="border-b border-border bg-secondary-light text-gray-one">
                                        <tr>
                                            <th scope="col" className="text-xs font-semibold px-3 py-2 whitespace-nowrap text-center">
                                                #
                                            </th>
                                            <th scope="col" className="text-xs font-semibold px-3 py-2 whitespace-nowrap text-left">
                                                Agent Name
                                            </th>
                                            <th scope="col" className="text-xs font-semibold px-3 py-2 whitespace-nowrap text-right">
                                                Total(RM)
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            commission?.groupTransactions.length > 0 ?
                                            commission.groupTransactions?.map((item, idx) => {
                                                return <tr key={ item._id } className={ 'border-border text-gray-two ' + (idx !== 0 ? 'border-t' : '') }>
                                                    <td className="px-3 py-2 whitespace-nowrap text-xs font-medium text-center">{ `${ idx + 1 }` }</td>
                                                    <td className="text-xs font-light px-3 py-2 whitespace-nowrap text-left">
                                                        { item.agent?.UserName }
                                                    </td>
                                                    <td className="text-xs font-light px-3 py-2 whitespace-nowrap text-right">
                                                        { thousandSeparator(item.totalCommission) }
                                                    </td>
                                                </tr>
                                            }) :
                                            <tr className='text-gray-two'>
                                                <td colSpan='100%' className="text-xs font-light px-3 py-2 whitespace-nowrap text-center">There is no data</td>
                                            </tr>
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default CommissionContent